import { render, staticRenderFns } from "./kmanswer.vue?vue&type=template&id=45d750e6&scoped=true&"
import script from "./kmanswer.vue?vue&type=script&lang=js&"
export * from "./kmanswer.vue?vue&type=script&lang=js&"
import style0 from "./kmanswer.vue?vue&type=style&index=0&id=45d750e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d750e6",
  null
  
)

export default component.exports